// test1654
(1654 && 0);
